import styled from '@emotion/styled'

import type { FC, PropsWithChildren } from 'react'

import * as Card from '@segment/matcha/recipes/Card'

interface LabelTextProps extends PropsWithChildren {
  courseNumber: number
}

const LabelText: FC<LabelTextProps> = ({ courseNumber, children }) => {
  return (
    <Card.AccessoriesRow>
      <StyledCardLabel variant="overline">Course {courseNumber}</StyledCardLabel>
      <StyledCardLabel variant="overline">•</StyledCardLabel>
      <LowercaseCardLabel variant="overline">{children}</LowercaseCardLabel>
    </Card.AccessoriesRow>
  )
}

export default LabelText

const StyledCardLabel = styled(Card.Label)`
  color: ${({ theme }) => theme.palette.twilio.green[60]};
`
const LowercaseCardLabel = styled(StyledCardLabel)`
  text-transform: none;
`
